import { atom } from "recoil";

export const LOADING = atom<boolean>({
    key: 'boolean',
    default: false
});

export interface Segment {
    segmentCode: string,
    segmentName: string
};

export interface DepositCode{
    id:string,
    code:string,
    description:string
}

export const SEGMENT_LIST = atom<Segment[]>({
    key: 'segment-list',
    default: []
});

export interface Category {
    categoryCode: string,
    categoryName: string,
    segmentCode: string
};

export const CATEGORY_LIST = atom<Category[]>({
    key: 'category-code',
    default: []
});

export const DEPOSIT_CODES_LIST = atom<DepositCode[]>({
    key:'desposit-codes',
    default:[]
})

export interface ProductStatus {
    statusCode: string,
    statusName: string
};

export const PRODUCT_STATUS_LIST = atom<ProductStatus[]>({
    key: 'product-status',
    default: []
});

export interface PaymentMethod {
    label: string,
    value: string
};

export const PAYMENT_METHDOS = atom<PaymentMethod[]>({
    key: 'payment-methods',
    default: []
});

export interface GuaranteeScheme {
    label: 'Full Credit' | 'Standard Credit' | 'No Credit',
    value: 'FULL_CREDIT' | 'STANDARD_CREDIT' | 'NO_CREDIT'
};

export const GUARANTEE_SCHEMES = atom<GuaranteeScheme[]>({
    key: 'guarante-schemes',
    default: []
});

export interface PaymentDueDate {
    label: string,
    value: string
};

export const PAYMENT_DUE_DATES = atom<PaymentDueDate[]>({
    key: 'payment-due-dates',
    default: []
});

export interface BillingMode {
    label: string,
    value: string
};

export const BILLING_MODES = atom<BillingMode[]>({
    key: 'billing-modes',
    default: []
});

export interface InvoiceRecipient {
    id: 'COMPANY' | 'CUSTOMER' | 'PERSON' | 'NA',
    recipientType: 'Company' | 'Customer' |  'Person' | 'NA'
}

export const INVOICE_RECIPIENTS = atom<InvoiceRecipient[]>({
    key: 'invoice-recipients',
    default: []
});

export const SEGMENTS_NO_GUARANTEE = atom<string[]>({
    key: 'segments-no-guarantee',
    default: ['SUB','JLR','RET']
});

export interface GuaranteePaymentMethodRel {
    code: string,
    paymentMethodCodes: string[]
}

export const GUARANTEE_PAYMENT_METHOD_REL = atom<GuaranteePaymentMethodRel[]>({
    key: 'guarantee-payment-method-rel',
    default: [
        {
            code: "FULL_CREDIT",
            paymentMethodCodes: ['B','D','A']
        },
        {
            code: "STANDARD_CREDIT",
            paymentMethodCodes: ['B','D','A']
        },
        {
            code: "NO_CREDIT",
            paymentMethodCodes: ['J']
        }
    ]
});

export interface PaymentTiming {
    id: number,
    value: string
};

export const PAYMENT_TIMINGS = atom<PaymentTiming[]>({
    key: 'payment-timing',
    default: []
});

export interface GuaranteePaymentTiming {
    code: 'FULL_CREDIT' | 'STANDARD_CREDIT' | 'NO_CREDIT',
    paymentTimingCodes: number[]
}

export const GUARANTEE_PAYMENT_TIMING_REL = atom<GuaranteePaymentTiming[]>({
    key: 'guarantee-payment-timing-rel',
    default: [
        {
            code: "FULL_CREDIT",
            paymentTimingCodes: [3]
        },
        {
            code: "STANDARD_CREDIT",
            paymentTimingCodes: [3]
        },
        {
            code: "NO_CREDIT",
            paymentTimingCodes: [1,2,3]
        }
    ]
});

export interface GuaranteeBillingMode {
    code: string,
    billingModeCodes: string[]
}

export const GUARANTEE_BILLING_MODE_REL = atom<GuaranteeBillingMode[]>({
    key: 'guarantee-billing-mode-rel',
    default: [
        {
            code: "FULL_CREDIT",
            billingModeCodes: ["S","D"]
        },
        {
            code: "STANDARD_CREDIT",
            billingModeCodes: ["S","D"]
        },
        {
            code: "NO_CREDIT",
            billingModeCodes: ["S"]
        }
    ]
});

export const SELECTED_CUSTOMER = atom<any>({
    key: 'customer_selected',
    default: {}
});

export const CUSTOMER_SELECTED_CREATE = atom<any>({
    key: 'customer_create_selected',
    default: {}
});